export default {
    title: "Home",
    button: {
        accessories: "Browse Catalog"
    },
    noAvailableItems: "The Peripheral Portal does not have any items available for your country at this time. Please work with your manager to procure the items you need.<br><br><a href='#' role='button' data-widget-trigger='{widgetOptions}'>Contact Support</a>",
    error: "There was a problem retrieving products. Please refresh your browser."
}